import { useState, useEffect } from 'react'
import Card from '../components/Card'

const convertTemperature = (value, from, to) => {
  if (isNaN(value) || value === '') return ''

  let celsius = 0

  // Convert to Celsius first
  switch (from) {
    case 'celsius':
      celsius = value
      break
    case 'fahrenheit':
      celsius = (value - 32) * (5 / 9)
      break
    case 'kelvin':
      celsius = value - 273.15
      break
    default:
      return ''
  }

  // Convert from Celsius to target
  switch (to) {
    case 'celsius':
      return celsius.toFixed(2)
    case 'fahrenheit':
      return ((celsius * 9) / 5 + 32).toFixed(2)
    case 'kelvin':
      return (celsius + 273.15).toFixed(2)
    default:
      return ''
  }
}

export default function TemperatureConverter() {
  const [fromUnit, setFromUnit] = useState('celsius')
  const [toUnit, setToUnit] = useState('fahrenheit')
  const [fromValue, setFromValue] = useState('')
  const [toValue, setToValue] = useState('')

  useEffect(() => {
    const result = convertTemperature(fromValue, fromUnit, toUnit)
    setToValue(result)
  }, [fromUnit, toUnit, fromValue])

  return (
    <div className="space-y-6">
      <Card>
        <Card.Body>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label className="label">From:</label>
              <select
                value={fromUnit}
                onChange={(e) => {
                  setFromUnit(e.target.value)
                }}
                className="input w-full mb-2"
              >
                <option value="celsius">Celsius (°C)</option>
                <option value="fahrenheit">Fahrenheit (°F)</option>
                <option value="kelvin">Kelvin (K)</option>
              </select>
              <input
                type="number"
                value={fromValue}
                onChange={(e) => setFromValue(e.target.value)}
                className="input w-full"
                placeholder="Enter temperature"
                step="0.01"
              />
            </div>
            <div>
              <label className="label">To:</label>
              <select
                value={toUnit}
                onChange={(e) => {
                  setToUnit(e.target.value)
                }}
                className="input w-full mb-2"
              >
                <option value="celsius">Celsius (°C)</option>
                <option value="fahrenheit">Fahrenheit (°F)</option>
                <option value="kelvin">Kelvin (K)</option>
              </select>
              <input
                type="number"
                value={toValue}
                readOnly
                className="input w-full bg-gray-50"
                placeholder="Result"
              />
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

